import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {getTableStyle} from "../utils/GridAllocationUtil";
import Text from "@amzn/meridian/text";

/**
 * Renders the aisle info section in the grid allocation view
 */
class AisleInfo extends Component {
    render() {
        const {aisleInfo, onClickAisleInfo} = this.props;
        return (
            <tr style={getTableStyle("none")} onClick={() => onClickAisleInfo(aisleInfo)}>
                <td key={"1"} style={getTableStyle("none")}>
                    <Text>{aisleInfo.label}</Text>
                </td>
                <td key={"2"} style={getTableStyle(aisleInfo.color)}>
                    <Text>{aisleInfo.reservedFor}</Text>
                </td>
            </tr>
        )
    }
}

const mapStateToProps = state => ({
});
export default withRouter(connect(mapStateToProps)(AisleInfo));


// WEBPACK FOOTER //
// ./src/components/gridAllocation/AisleInfo.js